<h1 mat-dialog-title>{{ 'INVOICE.ERROR_DIALOG.TITLE' | translate }}</h1>

<mat-dialog-content>
  <span>{{ 'INVOICE.ERROR_DIALOG.MESSAGE' | translate }}</span>
  <ul>
    <li>{{ error }}</li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="btn-margin" color="warn" [mat-dialog-close]="undefined">
    <span>Ok</span>
  </button>
</mat-dialog-actions>
